export const actionTypes = {
  SELLOUT_UPLOAD_IMDL_ROLES: "SELLOUT_UPLOAD_IMDL_ROLES",
  SET_SELLOUT_UPLOAD_IMDL_ROLES: "SET_SELLOUT_UPLOAD_IMDL_ROLES",
  SETLLOUT_UPLOAD_FILES: "SETLLOUT_UPLOAD_FILES",
  SELLOUT_GET_FILTERED_APPROVALS: "SELLOUT_GET_FILTERED_APPROVALS",
};

export const actions = {
  getSelloutImdlRoles: (payload) =>({
    type: actionTypes.SELLOUT_UPLOAD_IMDL_ROLES,
    payload: payload,
  }),

  setSelloutImdlRoles: (payload) => ({
    type: actionTypes.SET_SELLOUT_UPLOAD_IMDL_ROLES,
    payload: payload,
  }),

  selloutUploadFiles: (payload) => ({
    type: actionTypes.SETLLOUT_UPLOAD_FILES,
    payload: payload,
  }),
};
